import {Layout} from "./Layout.js";
import {getUserId} from "../../store.js";


export class UserProfileLayout extends Layout {
    template() {
        const {sectionId = '', userId = ""} = this.$props;
        return `
                <section id="${sectionId}" class="signup-wide-pop btn-bottom-case">
                    <header class="js-section-header"></header>
                    <article>
                        <div class="pop-main js-contents-main">
                            ${this.getMainTextTemplate()}
                            ${this.getSubTextTemplate()}
                            <ul>
                                ${this.getUserEmailInputTemplate()}
                                <li id ="userNameLayer"> </li>
                                <li id ="passwordLayer"> </li>
                                <li id= "jobSelectorLayer" class="select-wrap"></li>
                              </ul>
                              <div class="bottom-button-wrap">
                                 ${this.getNexPageButtonTemplate()}
                              </div>
                        </div>
                    </article>
                </section>`
    }

    getUserNameLayer() {
        return $("#userNameLayer")
    }

    getPasswordLayer() {
        return $("#passwordLayer")
    }

    getJobSelectorLayer() {
        return $("#jobSelectorLayer")
    }

    getUserEmailInputTemplate() {
        if (Often.isGlobal()) {
            return ``
        }
        const userId = getUserId();
        return `<li>
                   <input type="text" placeholder="${userId}" value="${userId}" disabled>
                 </li>`
    }

    getNexPageButtonTemplate() {
        const {nextButton = {}} = this.$props;
        return Object.values(nextButton).length > 0 ? `<button id = "${nextButton.id}" class="js-next-page-button button-sign-next" tabindex="4" >${Mutil.n2v(nextButton.text)}</button>` : "";
    }
}